import { render, staticRenderFns } from "./skill_submit.vue?vue&type=template&id=15e4b4e7&"
import script from "./skill_submit.vue?vue&type=script&lang=js&"
export * from "./skill_submit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports